/* eslint-disable camelcase, no-extra-parens */

import { Card, Col, Row } from "react-bootstrap";
import PropTypes from "prop-types";
import { useMemo } from "react";

import EqqoPieChart from "../../EqqoPieChart";
import NextPrevLinks from "../../components/NextPrevLinks";
import SectionIntroduction from "../components/SectionIntroduction";
import { imageUrlsToImage } from "../../helpers/charts";
import { useReport } from "../ReportContext";
import { useUser } from "../../UserContext";

import DependantImage from "../../../assets/icons/dependent.png";
import DisconnectedImage from "../../../assets/icons/disconnected.png";
import IndependentImage from "../../../assets/icons/independent.png";
import InterdependentImage from "../../../assets/icons/interdependent.png";
import RSBadge from "../components/RSBadge";
import RelationshipPercentile from "../components/RelationshipPercentile";
import RelationshipStrategyAssessment from "../components/RelationshipStrategyAssessment";


const RelationshipStrategies = ({ showHeader }) => {
	const { respondent } = useUser();
	const { reportContent: { acf: { relationship_strategies } } } = useReport();

	const stats = useMemo(() => respondent?.weqProfile?.stats, [respondent]);

	return (
		<>
			{showHeader ? <><h1>Your Relationship Strategies</h1><hr /></> : null}
			<div className="report-view">
				<SectionIntroduction
					text={relationship_strategies.introduction}
					videoUrl={`https://fast.wistia.net/embed/iframe/ryxo5hjr6u`}
				/>
				<section id="relationship-strategies-overview">
					<h2>Summary of Your Relationship Strategies</h2>

					<Card body className="my-4 bg-white">
						<EqqoPieChart
							className="d-none d-lg-block"
							colors={["#FFAE4C", "#8979FF", "#FF928A", "#3CC3DF"]}
							images={imageUrlsToImage([
								DisconnectedImage,
								InterdependentImage,
								IndependentImage,
								DependantImage
							])}
							labels={["Disconnected", "Interdependent", "Independent", "Dependent"]}
							options={{
								distFromCenter: 60
							}}
							scores={[
								stats?.lSLO_dist,
								stats?.hSO_dist,
								stats?.hSLO_dist,
								stats?.lSHO_dist,
							]} />

						<Row className="d-lg-none d-md-flex d-sm-flex" md={2} sm={2}>
							{
								["Interdependent", "Independent", "Dependent", "Disconnected"].map(strategy => (
									<Col className="mb-2" key={strategy}><RSBadge strategy={strategy} /></Col>
								))
							}
						</Row>


					</Card>
				</section>
				<section>
					<h2>Information about your use of the Interdependent Strategy</h2>
					<RelationshipPercentile strategy="interdependent" />
					
					<div
						className="relationship-strategy-introduction"
						dangerouslySetInnerHTML={{ __html: relationship_strategies.interdependent.introduction }}
					/>

					<RelationshipStrategyAssessment strategy="interdependent" />

				</section>
				<section>
					<h2>Information about your use of the Independent Strategy</h2>
					<RelationshipPercentile strategy="independent" />
					
					<div
						className="relationship-strategy-introduction"
						dangerouslySetInnerHTML={{ __html: relationship_strategies.independent.introduction }}
					/>

					<RelationshipStrategyAssessment strategy="independent" />
				</section>
				<section>
					<h2>Information about your use of the Dependent Strategy</h2>
					<RelationshipPercentile strategy="dependent" />
					
					<div
						className="relationship-strategy-introduction"
						dangerouslySetInnerHTML={{ __html: relationship_strategies.dependent.introduction }}
					/>

					<RelationshipStrategyAssessment strategy="dependent" />
				</section>
				<section>
					<h2>Information about your use of the Disconnected Strategy</h2>
					<RelationshipPercentile strategy="disconnected" />
					
					<div
						className="relationship-strategy-introduction"
						dangerouslySetInnerHTML={{ __html: relationship_strategies.disconnected.introduction }}
					/>

					<RelationshipStrategyAssessment strategy="disconnected" />

					<NextPrevLinks
						nextSection={{ label: "Back to Dashboard", link: "/profile/dashboard" }}
					/>
				</section>
			</div>
		</>
	);
};

RelationshipStrategies.propTypes = {
	showHeader: PropTypes.bool
};

RelationshipStrategies.defaultProps = {
	showHeader: false
};

export default RelationshipStrategies;
